
export default {
    data(){
        var checkemail = (rule, value, callback) => {
          var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
          if (!reg.test(value)) {
            return callback(new Error('邮箱格式错误'));
          }else{
            callback()
          }
        };
        return {
          header:{
            islogin: localStorage.getItem('ticket')
          },
          loading:false,
          stepActive:0,
          form:{
            type:1, //工单类型
            title:'',
            msg:'',
            email:this.$store.state.mail,
            realname:this.$store.state.usernick,
            image:[],
          },
          rules:{
            realname: [
              { required: true, message: '请输入姓名', trigger: 'blur' },
            ],
            email: [
              { required: true, message: '请输入邮箱', trigger: 'blur' },
              { validator: checkemail, trigger: 'blur' },
            ],
            title: [
              { required: true, message: '请输入工单标题', trigger: 'blur' },
            ],
            msg: [
              { required: true, message: '请输入工单内容', trigger: 'blur' },
            ],
          }
        }
    },
    mounted(){
      this.realname = this.$store.state.usernick
      this.email=this.$store.state.email
    },
    methods:{
      // 上传之前的限制函数
      beforeAvatarUpload (file) {
        if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
          this.$notify.warning({
            title: '警告',
            message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
          })
          return false
        }
        let size = file.size / 1024 / 1024 / 2
        if (size >= 1) {
          this.$notify.warning({
            title: '警告',
            message: '图片大小必须小于等于1M'
          })
          return false
        }
      },
      next(){
        this.stepActive+=1
      },
      // 选择类型
      chooseType(num){
        this.form.type = num
      },
      onSubmit(){
        this.$refs.form.validate(async bool=>{
          if(bool){
            this.loading=true
            try {
              const { data } = await this.$http.post('/orders/orderssubmit',this.form)
              if(data.status == 'success'){
                this.loading=false
                this.$message.success(data.msg)
                this.stepActive+=1
              }else {
                this.loading=false
                this.$message.error(data.msg)
              }
            }catch (e){
              this.loading=false
              this.$message.error('网络异常,请稍后重试')
            }
          }
        })
      },
      uploadImg(response, file, fileList){
        if(response.status!='success'){
          this.$message.error('图片上传失败')
        }else{
          this.form.image=[]
          fileList.forEach(item=>{
            if(item.response.status=='success'){
              this.form.image.push(item.response.data[0])
            }
          })
        }
      }
    }
}
